import React from 'react'
import { getClassNames } from '../../../_utils/classnames'
import { IJourneyWizard } from '../interfaces'
import { DomainDto } from '../../../dtos/domain'
import { simpleNotification } from '../../../_utils/utils'
import { JourneyBuilderMode as WizardBuilderMode } from '../../journey-builder/enums'
import { JourneysBuilder } from '../../../features/journeys/journeys-builder'
import { JourneyBuilderMode } from '../../../features/journeys/enums'
import { Journey } from '../../../features/journeys/types/journey-api-response'
import { StepType } from '@pushly/models/lib/enums/journeys'
import { isTriggerStep } from '@pushly/models/lib/structs/journeys'

interface IJourneyBuilderTab extends IJourneyWizard {
    domain: DomainDto
    activeTab?: boolean
}

interface IState {
    tmpValue?: Journey
}

export class JourneyBuilderTab extends React.Component<IJourneyBuilderTab, IState> {
    public static tabName = 'builder'
    public static tabLabel = 'Visual Builder'

    public state: IState = {}

    public componentDidUpdate(prevProps: Readonly<IJourneyBuilderTab>) {
        if (!!prevProps.journey !== !!this.props.journey) {
            this.setState({ tmpValue: this.props.journey })
        }
    }

    public render() {
        const journey = this.currentJourneyState
        if (!journey) {
            return null
        }

        const journeyMode =
            this.props.mode === WizardBuilderMode.CREATE
                ? JourneyBuilderMode.CREATE
                : this.props.mode === WizardBuilderMode.EDIT
                ? JourneyBuilderMode.EDIT
                : JourneyBuilderMode.READONLY

        return (
            <div className={getClassNames('cwzd-builder')}>
                <JourneysBuilder
                    ref={this.props.wizardRef}
                    loading={this.props.loading}
                    domain={this.props.domain}
                    journey={journey}
                    domainIntegrations={this.props.integrations}
                    onChange={this.handleUpdate}
                    onSubmit={this.handleSubmit}
                    mode={journeyMode}
                />
            </div>
        )
    }

    protected get currentJourneyState(): Journey | undefined {
        return this.state.tmpValue ?? this.props.journey
    }

    protected validate(journey: Journey): { ok: boolean; error?: any } {
        const res: any = { ok: true, error: undefined }

        const setNotOk = (reason: string) => {
            res.ok = false
            res.error = reason
        }

        const steps = journey.steps ?? []
        const trigger = steps.find((s) => s.type === StepType.TRIGGER)
        const actions = steps.filter((s) => s.type === StepType.ACTION)

        if (!trigger || !isTriggerStep(trigger) || !trigger.configuration?.type || !trigger.configuration?.params) {
            setNotOk('Journey entry conditions have not been set.')
        } else if (actions.length === 0) {
            setNotOk('At least one journey action is required.')
        }

        return res
    }

    protected handleUpdate = (journey: Journey) => {
        this.setState({ tmpValue: journey })
    }

    protected handleSubmit = async (journey: Journey, remove?: boolean) => {
        if (!journey && this.state.tmpValue) {
            journey = this.state.tmpValue
        }

        const res = this.validate(journey)

        if (!res.ok) {
            simpleNotification('error', res)
        } else {
            const submitRes = this.props.onSubmit?.(journey, remove)
            if (submitRes.ok) {
                this.setState({ tmpValue: submitRes.data })
            }

            return submitRes
        }

        return res
    }
}
